import * as Yup from 'yup';

export const LoginValidation = Yup.object().shape({
  userName: Yup.string().min(1).max(30).required('CPF/Cartão não encontrado'),
  password: Yup.string().min(1).max(30).required('Senha inválida ou incorreta')
})
